import script from "./ScoringPanelistsManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScoringPanelistsManager.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__